var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAppDispatch } from 'root/src/client/logic/helpers/useStore';
import { useUser } from 'root/src/client/logic/auth/hooks/useUser';
import { useCreatorData } from 'root/src/client/logic/api/hooks/useCreatorData';
import auditFollowCreator from 'root/src/client/logic/creatorData/thunks/auditFollowCreator';
import displayModal from 'root/src/client/logic/modal/thunks/displayModal';
import { FOLLOW_CREATOR_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
import { useMemo } from 'react';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ActionModalContextProvider } from 'root/src/client/v2/_pages/ambassador-program/hooks/useActionModal';
import { AddCreatorsToProgramModal, } from 'root/src/client/v2/_pages/ambassador-program/components/AddCreatorsToProgramModal';
import { useMutation } from '@tanstack/react-query';
import { CreatorSettingsModal } from 'root/src/client/v2/creator/components/CreatorSettingsModal';
export const useCreatorDataActionButtons = () => {
    const dispatch = useAppDispatch();
    const user = useUser();
    const isAuthenticated = Boolean(user === null || user === void 0 ? void 0 : user.authentication);
    const creatorData = useCreatorData();
    const modal = useModal();
    const isTransformableToCreator = useMemo(() => {
        var _a;
        const authentication = user === null || user === void 0 ? void 0 : user.authentication;
        if (!isAuthenticated) {
            return false;
        }
        const isCreator = (_a = authentication === null || authentication === void 0 ? void 0 : authentication.groups) === null || _a === void 0 ? void 0 : _a.includes(AuthGroup.Creator);
        if (isCreator) {
            return false;
        }
        return (creatorData === null || creatorData === void 0 ? void 0 : creatorData.userId) === (authentication === null || authentication === void 0 ? void 0 : authentication.userId);
    }, [user, creatorData]);
    const handleFollow = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!creatorData)
            return;
        if (isAuthenticated) {
            yield dispatch(auditFollowCreator());
            return;
        }
        dispatch(displayModal(FOLLOW_CREATOR_MODAL_MODULE_ID, { username: creatorData.mnemonicId }));
    });
    const followMutation = useMutation({
        mutationFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return handleFollow();
        }),
        mutationKey: ['followCreator', creatorData === null || creatorData === void 0 ? void 0 : creatorData.userId],
    });
    const onAddToProgram = () => {
        if (!creatorData) {
            return;
        }
        const creator = {
            userId: creatorData.userId,
            creatorDatas: [],
            programs: [],
            isOutsideCreator: false,
        };
        modal.show(<ActionModalContextProvider provider={{ selectedCreators: [creator] }}>
				<AddCreatorsToProgramModal />
			</ActionModalContextProvider>);
    };
    const onOpenSettings = () => {
        modal.show(<CreatorSettingsModal />);
    };
    return {
        isTransformableToCreator,
        followMutation,
        onAddToProgram,
        onOpenSettings,
    };
};
